module.exports = __webpack_public_path__ + "a8313ee1ccaa90cebf608364ac777d2d.pdf";